import React from 'react';
import PropTypes from 'prop-types';

export const staticField = ({
  value = ''
}) =>
  <div
    className="form-control static-field"
    title={value}>
    {value}
  </div>;

staticField.propTypes = {
  value: PropTypes.string
};

export default staticField;
